/**
 * 몬스터 정의. 레벨/HP/경험치/공격력은 `monsters.json`.
 */

import seed from './monsters.json';
import { emitDataReloadSoon, replaceRecord, requireRecord } from './catalog';
import type { StatusId } from './status';

export type MonsterMove = 'walk' | 'hop' | 'drift';

export interface StatusInflict {
  status: StatusId;
  chance: number;
}

export interface MonsterJumpAttack {
  range: number;
  cooldownMs: number;
  vx: number;
  vy: number;
}

export interface MonsterRangedAttack {
  min: number;
  max: number;
  cooldownMs: number;
  speed: number;
}

export interface MonsterAi {
  aggroRange: number;
  deaggroMs: number;
  chaseSpeed: number;
  sameLevelPx: number;
  jump?: MonsterJumpAttack;
  ranged?: MonsterRangedAttack;
}

export interface MonsterDrop {
  itemId: string;
  chance: number;
  min: number;
  max: number;
}

export interface MonsterDef {
  id: string;
  name: string;
  level: number;
  maxHp: number;
  attack: number;
  defense: number;
  exp: number;
  moveStyle: MonsterMove;
  moveSpeed: number;
  hopVelocity?: number;
  moveIntervalMs: number;
  patrolRange: number;
  knockbackResist: number;
  accuracy: number;
  avoid: number;
  ai?: MonsterAi;
  inflict?: StatusInflict;
  texture: string;
  body: { width: number; height: number };
  displayHeight: number;
  meso: { min: number; max: number };
  drops: readonly MonsterDrop[];
}

export const MONSTERS: Record<string, MonsterDef> = structuredClone(seed.MONSTERS) as Record<
  string,
  MonsterDef
>;

export function applyMonsters(raw: unknown): void {
  const data = requireRecord(raw, 'monsters.json');
  replaceRecord(
    MONSTERS,
    structuredClone(requireRecord(data.MONSTERS, 'MONSTERS')) as Record<string, MonsterDef>,
  );
}

if (import.meta.hot) {
  import.meta.hot.accept('./monsters.json', (mod) => {
    if (!mod?.default) return;
    applyMonsters(mod.default);
    emitDataReloadSoon();
  });
}
